const shortPersistentIdLength = 8;
const alphanumeric = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

export function generateShortPersistentId() {
  return generateAlphanumericId(shortPersistentIdLength);
}

function generateAlphanumericId(length: number): string {
  let randomString = "";

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * alphanumeric.length);
    randomString += alphanumeric.charAt(randomIndex);
  }

  return randomString;
}
